// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__XLQ3t","paramInput":"JobSimulator_paramInput__2Gbv3","input":"JobSimulator_input__2tUe0"};